import {
  API_METHOD_PUT,
  API_PROFILE_COOKIES_CONSENT,
} from '@/constants/apiConstants';
import { apiCall } from '@/utility/api/apiUtils';
import { generateHash } from '@/utility/auth/generateHashValue';
import { CookieConsent } from '@/utility/consent/cookieConsent';
import { Method } from 'axios';

export const saveCookieConsent = async (consent: CookieConsent) => {
  const method: Method = API_METHOD_PUT;
  const url = API_PROFILE_COOKIES_CONSENT;
  const data = {
    analytics: consent.analytics,
    platform: 'web',
    consent_version: consent.version,
    decided_at: consent.decidedAt,
  };
  const additionalHeaders = {
    hash: generateHash(JSON.stringify(data)),
  };

  return apiCall({
    method,
    url,
    data,
    headers: additionalHeaders,
    suppressErrorToast: true,
  });
};
